module.exports = __webpack_public_path__ + "img/launchyou-logo-flat-white.e0ad0695.svg";